import { useEffect } from "react";
import { useGetSsoUrlQuery } from "pages/online-verification/verificationService";
import { LoadingOverlay } from "components/ui/loading-spinners";
import Modal from "components/modal/Modal";
import "./sso-iframe.scss";
import { Spinner } from "components/v2/spinner/spinner";

export const SsoIframe = ({
  orderId,
  showModal,
  toggleModal,
  onClose,
  handleError,
  forDashboard = false,
}: {
  orderId: string;
  showModal: boolean;
  toggleModal: () => void;
  onClose: () => void;
  handleError: (isError: boolean) => void;
  forDashboard?: boolean;
}) => {
  const { data, isSuccess, isLoading, isError } = useGetSsoUrlQuery(orderId);

  useEffect(() => {
    const handleCloseFrame = (event: MessageEvent) => {
      if (event.data == "closeFrameTimeout") {
        toggleModal();
        handleError(true);
        globalThis.removeEventListener("message", handleCloseFrame);
      } else if (event.data == "closeFrame") {
        onClose();
      }
    };
    globalThis.addEventListener("message", handleCloseFrame);
    return () => globalThis.removeEventListener("message", handleCloseFrame);
  }, []);

  useEffect(() => {
    if (isError) {
      toggleModal();
      handleError(true);
    }
  }, [isError, toggleModal, handleError]);
  
  return (
    <div className={`voa-popup ${forDashboard ? "voa-popup--dashboard" : ""}`}>
      {showModal && (
        <Modal
          customBody={
            <>
              {!forDashboard && isLoading && <LoadingOverlay />}
              {forDashboard && isLoading && <Spinner isApi />}
              {forDashboard && isSuccess && <div className="voa-popup__iframe-wrapper"></div>} {/* Empty div to hide iframe scrollbar */}
              {isSuccess && <iframe src={data.url} title="SSO Verification"></iframe>}
            </>
          }
        />
      )}
    </div>
  );
};
